import { TIconNames } from 'src/components/BaseIcon/IconNames.types';

export type TMarketDesign = {
  className?: string;
};

export type TStylesScrolling = {
  maxSize?: number;
  minSize?: number;
  minBright?: number;
  darker?: boolean;
};

export type TMenuLayers = {
  title: string;
  layer: number;
  icon: TIconNames;
};

export type TLayers = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: React.ComponentType<any>;
  customClass?: string;
  config: {
    sticky?: {
      start: number;
      end: number;
    };
    className?: string;
    offset?: number;
    speed?: number;
    factor?: number;
  };
  props?: {
    withLayers: number[];
  };
};

export enum ELayersGroup {
  INITIAL = 'initial',
  EXCHANGES = 'exchanges',
  BLUEBOX = 'bluebox',
  MARKETS = 'markets',
  APIS = 'apis',
  SIMULATION = 'simulation',
  DEPLOYMENT = 'deployment',
  ECOSYSTEM = 'ecosystem',
}

export enum EMenus {
  FIRST = 'first',
  SECOND = 'second',
}

export type TMarketDesignContextValues = {
  isDocVisible: boolean;
  currentLayer: number;
  isEcoSystemChildView: boolean;
  isLandscape: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // setEcoSystemChildView?: any;
};
